import Vue from "vue"
import Vuex from "vuex"
import buildModule from "@/modules/_registration.js"
import global from "@/utils/global.js"
import { rm } from "shelljs"
import AES from "crypto-js/aes"
import _config from "@/config.js"
const { default: router } = require("@/router")
import NotFound from "@/default-page/not-found"

Vue.use(Vuex)
const state = {
  lang: localStorage.getItem('lang') || "id",
  sideNavPrimary: false,
  sideNavSecondary: false,
  sideNavMobile: false,
  unitProductionId: parseInt(localStorage.getItem("unitProductionId")) || null,
  temporary_date: JSON.parse(localStorage.getItem("temporary_date")) || [],
  config: {},
  loading: false,
  profile: JSON.parse(localStorage.getItem('profile')) || {},
  program_year: _config.options.yearDefault,
  year_options: _config.options.yearOptions || [],
  role_code: null,
  role_name: null,
}

const mutations = {
  toggleState (state, variable) {
    state[variable] = !state[variable]
  },
  setOffSidebar (state) {
    state.sideNavSecondary = false
  },
  set (state, [variable, value, saveLS = false]) {
    if (variable === "temporary_date" && Array.isArray(value) && value.length > 0 && !value[0]) {
      return
    }
    
    Vue.set(state, variable, value);
    // if (saveLS) localStorage.setItem(variable, _variable === '_token' ? value : AES.encrypt(JSON.stringify(value), _config.appkey).toString())
    if (saveLS) localStorage.setItem(variable, JSON.stringify(value))
  }
}
const getters = {
  lang: state => state.lang,
  production_unit: state => state.production_unit,
  profile: state => state.profile,
  temporary_up_id: state => state.temporary_up_id,
  temporary_corporate_id: state => state.temporary_corporate_id,
  allow_guides: state => state.allow_guides,
  corporate: state => state.corporate,
  date: state => state.temporary_date,
  config: state => state.config,
  loading: state => state.loading,
}
const actions = {
  setModule: async function (context) {
    await buildModule.then(res => {
      var allowedModule = []
      for (var index = 0; index < res.length; index++) {

        // const elm = res[index]
        const elm = Object.assign({}, res[index]) // remove fucking binding
        var tmpRoute = []
        for (var i = 0; i < elm.routes.length; i++) {
          const r = Object.assign({}, elm.routes[i]) // remove fucking binding

          if (r.meta.permission) {
            if (r.meta.permission.read.indexOf("|") > -1) {
              var permissionArr = r.meta.permission.read.split("|")
              var hasPermission = false

              for (const _perm of permissionArr) {
                if (global.isAllowed(_perm)) {
                  hasPermission = true
                }
              }

              if (hasPermission) {
                tmpRoute.push(r)
              }
            } else if (global.isAllowed(r.meta.permission.read)) {
              tmpRoute.push(r)
            } else {
            }
          } else {
            tmpRoute.push(r)
          }
        }

        
        var data = elm
        data.routes = tmpRoute
          
        if (tmpRoute.length > 0) allowedModule.push(data)
      }
      

      context.commit("set", ["modules", allowedModule.filter(x => !x.hide), true])

      // router.addRoute(
      // { path: "*", component: NotFound })
    })
  },
}

export default new Vuex.Store({ state, mutations, getters, actions })



// WEBPACK FOOTER //
// ./src/utils/store.js